<template lang="pug">
div.box
    v-server-table(
        :url="api",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
</template>

<script>
import receiptMixin from '@js/mixins/receipt';

export default {
    mixins: [receiptMixin],

    data: function() {
        var that = this;
        return {
            tableName: 'STAFF_SALES',
            columns: [
                'code',
                'product_name',
                'variant_name',
                'category_name',
                'tags',
                'total_quantity',
                'receipt_number',
                'table_name',
                'staff_name',
                'total_net_sales',
                'creation_date',
            ],
            options: {
                texts: {
                    title: 'Product Sales by Staff',
                    description: 'Shows product sales by staff',
                },
                customFilters: ['outlet_id', 'since', 'until'],
                useReportFilter: true,
                headings: {
                    product_name: 'Product',
                    variant_name: 'Variant',
                    category_name: 'Category',
                    receipt_number: 'Receipt No.',
                    total_quantity: 'Quantity',
                    table_name: 'Table',
                    staff_name: 'Staff',
                    total_net_sales: 'Total net sales',
                },
                templates: {
                    receipt_number: (h, row) => {
                        return this.receiptNumberFormat(row);
                    },
                    creation_date: (h, row) => {
                        return this.receiptDateFormat(row.creation_date);
                    },
                    total_net_sales: (h, row) => {
                        return numeral(
                            parseFloat(row.total_net_sales),
                        ).format();
                    },
                },
                orderBy: {
                    ascending: false,
                    column: 'creation_date',
                },
                pdf_url: Laroute.route('franchise.report.item.staff.export', {
                    type: 'PDF',
                }),
                csv_url: Laroute.route('franchise.report.item.staff.export', {
                    type: 'CSV',
                }),
                xls_url: Laroute.route('franchise.report.item.staff.export', {
                    type: 'XLSX',
                }),
            },
        };
    },
    computed: {
        api() {
            return Laroute.route('franchise.report.item.staff.index');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/vuetable-staff-sales.vue